import { version } from './version';

export const environment = {
  version: version,
  production: false,
  redirectUrl: 'https://app.service-dev.medien-haus.de',
  serviceUrl: 'https://api.service-dev.medien-haus.de',
  auth0Domain: 'dev-kla20y6xcdja28s1.us.auth0.com',
  auth0ClientId: 'O7KqRNHCZ7exwWyjD1aPtoErsQDJTQzB',
  bucketUrl: 'https://storage.googleapis.com/markant-mediabase-stage',
  sharedienUrl: 'https://dev.dam.markant.services',
  sharedienCdnUrl: 'https://assets.dev.dam.markant.services',
};
